import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ToastContext from "../../../../contexts/toast.js";
import { RichiestaService } from "../../../../services/RichiestaService.js";
import Input from "../../../Form/Input.js";
import InputIban from "../../../Form/InputIban";
import { FormUtility } from "../../../Utility/FormUtility.js";

import { IMaskInput } from "react-imask";
import DatePicker from "../../../Form/DatePicker.js";

import AlertMessage from "../../../Utility/Alert/AlertMessage.js";

import Checkbox from "../../../Form/Checkbox.js";


import moment from "moment";

import protocolloDsu from "../../../../assets/img/protocolloDsu.png";
import StatusContext from "../../../../contexts/status.js";
import { DatiUtenza } from "../../../../models/DatiUtenza.js";
import Modal from "../../../Utility/Modal/Modal.js";

const RettificaRipresentazione = (props) => {
    const [richiesta, setRichiesta] = useState({});
    const scrollRef = useRef(null);
    const formRef = useRef(null);
    const [dirty, setDirty] = useState(false);
    const toastContext = useContext(ToastContext);
    const { id } = useParams();
    const [dsu, setDsu] = useState("");
    const [errorDsu, setErrorDsu] = useState(false);
    const [showError, setShowError] = useState(false);
    const [inSave, setInSave] = useState(false);
    const [inputErrors, setInputErrors] = useState([]);
    const [startUp, setStartup] = useState(true);
    const [loading, setLoading] = useState(true);
    const [etaMillesimo, setEtaMillesimo] = useState(null);
    const [richiestaDatiBeneficiario, setRichiestaDatiBeneficiario] = useState(
        new DatiUtenza()
    );
    const [validate, setValidate] = useState(false);
    const statusContext = useContext(StatusContext);
    const [onChangeValueReset, setOnChangeValueReset] = useState(null);
    const [informativa1, setInformativa1] = useState(false);
    const [informativa2, setInformativa2] = useState(false);
    const [informativa3, setInformativa3] = useState(false);

    const [isModalOpen, setModalOpen] = useState(false);
    const [title, setTitle] = useState(null);
    const [content, setContent] = useState(null);
    const [icon, setIcon] = useState(false);
    const [hideCloseButton, setHideCloseButton] = useState(false);
    const [actionLabel, setActionLabel] = useState(false);
    const [codice, setCodice] = useState(null);
    const navigate = useNavigate();
    const [iconaClass, setIconaClass] = useState(null);
    const [iconaColorClass, setIconaColorClass] = useState(null);
    const [firstTime, setFirsTime] = useState(true);
    const [saveDone, setSaveDone] = useState(false);
    const [] = useState(null);

    const [errorIban, setErrorIban] = useState(false);
    const [richiestaDatiPagamento, setRichiestaDatiPagamento] = useState({});

    const dsuInputRef = useRef(null);

    const richiestaService = new RichiestaService();

    const utility = new FormUtility();

    const map = {
        informativa1: setInformativa1,
        informativa2: setInformativa2,
        informativa3: setInformativa3,
    };

    const onChangeValueCheckBox = (event) => {
        const target = event.target;
        const set = map[target.name];
        set(target.checked === true);
        onModifiedData(validate,false);
    };

    const setFormErrors = (setFocus = true) => {
        const errors = utility.getAllInputErrors(formRef);
        setInputErrors(errors.map((el) => el.id));
        if (setFocus && errors.length > 0) {
            errors[0].focus();
        }
    };

    const onModifiedData = (updateFormErrors = true, updateDirty = true) => {
        console.log('onmodifieddata',updateDirty);
        if (updateFormErrors) {
            setTimeout(() => {
                setFormErrors(false);
            }, 0);
        }

        if (updateDirty) {
            statusContext.addEvent("onbeforeunload");
            setDirty(true);
        }
    };

    const calculateFiscalCodeData = (richiestaDatiBeneficiario, value, dataPresentazione) => {
        if (value.length === 16) {
            richiestaDatiBeneficiario.eta = utility.ottieniEtaDaCodiceFiscaleRettifica(
                value.toUpperCase(), new Date(dataPresentazione?.replace(' ', 'T'))
            );
            richiestaDatiBeneficiario.dataNascita = moment(
                utility.ottieniDataNascitaDaCodiceFiscale(value.toUpperCase())
            ).format("YYYY-MM-DD");
            setEtaMillesimo(
                utility.ottieniEtaMillesimoDaCodiceFiscaleRettifica(
                    value.toUpperCase(),
                    new Date(dataPresentazione?.replace(' ', 'T'))
                )
            );
        } else {
            richiestaDatiBeneficiario.eta = null;
            richiestaDatiBeneficiario.dataNascita = null;
        }

        richiestaDatiBeneficiario.codiceFiscale = value;

        setRichiestaDatiBeneficiario({ ...richiestaDatiBeneficiario });
    }

    const onChangeCodiceFiscale = (event) => {
        const value = event.target.value;

        calculateFiscalCodeData(richiestaDatiBeneficiario, value, richiesta.dataPresentazione);

        onModifiedData(validate);
        setDirty(true);
    };

    useEffect(() => {
        scrollRef?.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, [richiesta]);


    const regExprFiscalCode =
        "^([A-Za-z]{6}[0-9LMNPQRSTUVlmnpqrstuv]{2}[ABCDEHLMPRSTabcdehlmprst][0-9LMNPQRSTUVlmnpqrstuv]{2}[A-Za-z][0-9LMNPQRSTUVlmnpqrstuv]{3}[A-Za-z])$";


    const getINPS_ISEE_CurrentYear = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        return `INPS-ISEE-${currentYear}-`;
    };

    const inpsIseeCurrentYear = getINPS_ISEE_CurrentYear();

    const getRichiesta = async () => {
        if (!id) return;
        const resp = await richiestaService.get(id);
        setRichiesta(resp);
        setCodice(resp.codice);
        calculateFiscalCodeData(resp?.richiestaDatiBeneficiario, resp?.richiestaDatiBeneficiario?.codiceFiscale || "", resp?.dataPresentazione);
        setDsu(resp?.richiestaDatiPagamento?.dsu);
        
        handleDsuChange(resp?.richiestaDatiPagamento?.dsu?.substring(15), false); 
        setRichiestaDatiPagamento({ ...resp.richiestaDatiPagamento });

        setLoading(false);
    }

    useEffect(() => {
        getRichiesta().finally(() => setStartup(false));
    }, []);

    const onChangeValue = async (event, field = "value", targetName = null) => {
        const target = event.target;
        const name = targetName ?? target.name;
        const value = target[field];

        if (!!props.richiesta?.richiestaRapportoBeneficiario &&
            !!props.richiesta?.richiestaIscrizioneScolastica &&
            (
                name === 'nome' ||
                name === 'cognome' ||
                name === 'codiceFiscale'
            )
        ) {
            setOnChangeValueReset(richiestaDatiBeneficiario[name] !== props.richiesta?.richiestaRapportoBeneficiario?.[name]);
        }


        if (name === "denominazioneBanca") {
            richiestaDatiPagamento[name] = value;
            setRichiestaDatiPagamento({ ...richiestaDatiPagamento });
        }
        else {
            richiestaDatiBeneficiario[name] = target[field];
            setRichiestaDatiBeneficiario({ ...richiestaDatiBeneficiario });
        }

        onModifiedData(validate);
    };

    const checkEtaValue = () => {
        if (etaMillesimo < 10) {
            return "Non è possibile presentare domanda per studenti con età inferiore ai 10 anni";
        }

        if (richiestaDatiBeneficiario.eta >= 24) {
            return 'Non è possibile presentare domanda per studenti con età uguale o maggiore di 24 anni';
        }

        return null;
    };


    const presentaDomanda = (event) => {
        console.log('aggiorna domanda');
        event.preventDefault();
        event.stopPropagation();
        setValidate(true);

        const isDsuOk = validaDsu(dsu);

        if (errorDsu || dsu === '') {
            setFormErrors();
            if (!isDsuOk)
                dsuInputRef.current.focus();
            setShowError(true);
            return;
        }

        setValidate(true);


        const validity = formRef.current.checkValidity();

        if (utility.checkLastCharCf(richiestaDatiBeneficiario.codiceFiscale?.toUpperCase())) {
            setInputErrors(prev => [...new Set([...prev, "codiceFiscaleBeneficiario"])]);
            const cfBeneficiario = [...formRef.current.elements].filter(el => el.id === "codiceFiscaleBeneficiario");
            cfBeneficiario[0].focus();
            return;
        }


        validazioneIBANItaliano(
            { target: { value: richiestaDatiPagamento.iban } },
            false
        );
        if (errorIban) {
            console.log("errore iban");
            setFormErrors();
            setShowError(true);
            return;
        }


        if (!validity) {
            setFormErrors();
            return;
        }

        if (checkEtaValue()) {
            toastContext.error('Età non valida');
            return;
        }

        
        
        setModalOpen(true);
        setIcon(true);
        setActionLabel("Conferma");
        setTitle("Attenzione");
        setIconaClass("solid--exclamation-triangle");
        setIconaColorClass("rtds-text-warn-dark");
        setHideCloseButton(false);
        if (dirty) {
            setContent("Attenzione! Proseguire con la rettifica della domanda?")
        } else {
            setContent("Attenzione! Non è stato modificato alcun dato, proseguire con la rettifica della domanda?")
        }
        return;

    };


    const handleModalAction = async () => {
        console.log('handleModalAction');
        if (!saveDone) {
            setInSave(true);

            setInputErrors([]);

            const body = {
                codiceFiscale: richiestaDatiBeneficiario.codiceFiscale.toUpperCase(),
                nome: richiestaDatiBeneficiario.nome,
                cognome: richiestaDatiBeneficiario.cognome,
                eta: richiestaDatiBeneficiario.eta,
                dataNascita: richiestaDatiBeneficiario.dataNascita,
                dsu: getINPS_ISEE_CurrentYear() + dsu,
                iban: richiestaDatiPagamento.iban,
                denominazioneBanca: richiestaDatiPagamento.denominazioneBanca
            }
            

            //const result = await richiestaService.aggiornaDomanda(id, body);

            richiestaService.rettificaDomandaRipresentazione(id, body).then((result) => {
                setRichiesta(result);
                setHideCloseButton(true);
                const msg = "Dati aggiornati con successo"
                toastContext.success(msg);
                statusContext.removeEvent("onbeforeunload");

                setDirty(false);
                setActionLabel("Chiudi");
                setTitle("Domanda rettificata!")
                setIcon(true);
                setIconaClass("solid--check-circle");
                setIconaColorClass("rtds-text-success-dark");
                setContent(`La domanda con codice '${codice}'. è stata rettificata correttamente. A seguito dei controlli verrà inviata un’e-mail di conferma della rettifica.`);
                setModalOpen(true);
                setSaveDone(true);
            })
                .catch((err) => {
                    toastContext.error(utility.getErrorMsg(err), 2500); setInSave(false);
                    setModalOpen(false);
                });





        } else {
            navigate("/dashboard");
        }


    }


    const handleDsuChange = (value, updateDirty = true) => {
        console.log(value,firstTime,startUp);
        if (!firstTime && updateDirty && !startUp) {
            setDirty(true);
        }
        if (value?.length > 8) {
            value = value.substring(0, 8) + value.substring(8, 9).toUpperCase() + value.substring(9);
        }

        const isValid = validaDsu(value);
        setErrorDsu(!isValid);
        setFirsTime(false);
        setDsu(value);


    };

    function validaDsu(dsu) {
        setErrorDsu(false);
        const regex = /^\d{8}[A-Za-z]-\d{2}$/;
        const ok = regex.test(dsu);
        setErrorDsu(!ok);
        return ok;
    }




    const validazioneIBANItaliano = (event, updateDirty = true) => {
        if (updateDirty) {
            setDirty(true);
        }

        setErrorIban(false);
        const iban = event.target.value.replace(/\s/g, "").toUpperCase();
        setRichiestaDatiPagamento({ ...richiestaDatiPagamento, iban: iban });
        const lunghezza = iban.length;
        const codicePaese = iban.substring(0, 2);

        if (codicePaese !== "IT") {
            setErrorIban(true);
            return false;
        }

        if (lunghezza !== 27) {
            setErrorIban(true);
            return false;
        }

        const cifreControllo = iban.substring(2, 4);
        const contoBase = iban.substring(4);
        let numeroRiorganizzato = contoBase + codicePaese + cifreControllo;
        numeroRiorganizzato = numeroRiorganizzato.replace(/[A-Z]/g, (lettera) => {
            return parseInt(lettera, 36);
        });

        let resto = numeroRiorganizzato;
        let blocco;
        while (resto.length > 2) {
            blocco = resto.substring(0, Math.min(9, resto.length));
            resto = (parseInt(blocco, 10) % 97) + resto.substring(blocco.length);
        }
        const isValid = parseInt(resto, 10) % 97 === 1;
        setErrorIban(!isValid);

        return isValid;
    };


    return (
        <>
            {/* Inizio Loading */}
            <section className="rtds-grid rtds-gap-4" hidden={!loading}>
                <div
                    className="rtds-empty-state rtds-grid rtds-gap-4"
                    aria-live="assertive"
                    aria-atomic="true"
                >
                    <div className="rtds-font-bold rtds-text-center rtds-grid rtds-gap-8 rtds-justify-center rtds-justify-items-center rtds-py-20">
                        <svg
                            className="rtds-icon rtds-fill-current rtds-w-16 rtds-h-16 rtds-animate-spin"
                            aria-hidden="true"
                            focusable="false"
                            role="img"
                        >
                            <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`} />
                        </svg>
                        <span className="rtds-sr-only">Caricamento...</span>

                        <h3 className="rtds-heading-4">
                            <div className="loading-message">
                                Attendere un momento
                                <span className="dots">...</span>
                            </div>
                        </h3>
                    </div>
                </div>
            </section>
            {/* Fine Loading */}

            <div
                className="rtds-container rtds-my-12"
                hidden={loading}
                ref={scrollRef}
            >
                <div
                    key={5}
                    id={`tabpanel-5`}
                    className="rtds-tablist__tabpanel"
                    role="tabpanel"
                    aria-labelledby={`tab-5`}
                >
                    <div className=" rtds-my-12 ">
                        <div className="rtds-mb-6">
                            <h1 className="rtds-text-2xl rtds-font-bold">
                                {`Dati da rettificare per la domanda ${codice || ""}`}
                            </h1>
                        </div>
                        <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
                            <AlertMessage
                                message="Compila attentamente questa sezione inserendo i dati corretti, sarà possibile rettificare la domanda solo in questa fase."
                                iconName="mini--information-circle"
                                title="Attenzione!"
                                classArticle="rtds-mb-6"
                            />

                            <div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
                                <p>
                                    I campi obbligatori sono contrassegnati da un asterisco&nbsp;
                                    <abbr
                                        className="rtds-font-bold rtds-no-underline"
                                        title="obbligatorio"
                                    >
                                        *
                                    </abbr>
                                </p>
                            </div>

                            <form
                                noValidate
                                ref={formRef}
                                id="hasValidationFor"
                                className="has-js-validation-form rtds-py-6 rtds-space-y-4"
                            >
                                <div id="div_container_isee" hidden={!richiesta?.hasErroreIseeBase}>
                                    <h2 className="rtds-text-xl rtds-font-bold">
                                        Dati identificativi dello studente
                                    </h2>
                                    <div className="rtds-field-row">
                                        <Input
                                            label={"Codice Fiscale dello studente"}
                                            id={"codiceFiscaleBeneficiario"}
                                            classInput={
                                                "rtds-text-sm rtds-input-placeholder rtds-uppercase"
                                            }
                                            type={"text"}
                                            pattern={regExprFiscalCode}
                                            onChange={(event) => onChangeCodiceFiscale(event)}
                                            value={richiestaDatiBeneficiario?.codiceFiscale || ""}

                                            maxLength={16}
                                            minLength={16}
                                            inputErrors={inputErrors}
                                            errorMessage={utility.checkFiscalCodeValidity(
                                                validate,
                                                richiestaDatiBeneficiario?.codiceFiscale,
                                                regExprFiscalCode
                                            )}
                                            required
                                        />

                                        <Input
                                            classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                            label={"Nome dello Studente"}
                                            id={"nomeBeneficiario"}
                                            classInput={
                                                "rtds-text-sm rtds-input-placeholder rtds-pr-12"
                                            }
                                            type={"text"}
                                            onChange={(event) => onChangeValue(event, "value", "nome")}
                                            value={richiestaDatiBeneficiario?.nome || ""}

                                            inputErrors={inputErrors}
                                            required
                                            maxLength={50}
                                        />

                                        <Input
                                            classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                            label={"Cognome dello Studente"}
                                            id={"cognomeBeneficiario"}
                                            classInput={"rtds-text-sm rtds-input-placeholder"}
                                            type={"text"}
                                            onChange={(event) => onChangeValue(event, "value", "cognome")}
                                            value={richiestaDatiBeneficiario?.cognome || ""}

                                            inputErrors={inputErrors}
                                            required
                                            maxLength={50}
                                        />
                                    </div>

                                    <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

                                    <h2 className="rtds-text-xl rtds-font-bold">
                                        Età dello studente
                                    </h2>
                                    <AlertMessage
                                        message="La data di nascita e l'età vengono calcolate automaticamente in base al Codice Fiscale inserito."
                                        iconName="mini--information-circle"
                                        title="Nota Bene!"
                                        classArticle="rtds-mb-6"
                                    />

                                    <div className="rtds-field-row">
                                        <DatePicker
                                            label={"Data di Nascita dello Studente"}
                                            id={"dataNascita"}
                                            inputErrors={inputErrors}
                                            classInput={"rtds-text-sm rtds-input-placeholder"}
                                            type={"date"}
                                            defaultValue={richiestaDatiBeneficiario?.dataNascita || ""}
                                            readOnly
                                            hideSubTitle
                                        />

                                        <Input
                                            classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                            label={"Età dello Studente al momento della presentazione della domanda"}
                                            id={"eta"}
                                            classInput={"rtds-text-sm rtds-input-placeholder"}
                                            type={"text"}
                                            value={richiestaDatiBeneficiario?.eta || ""}
                                            readOnly
                                        />
                                    </div>
                                    <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

                                    <h2 className="rtds-text-xl rtds-font-bold">ISEE</h2>
                                    <p>
                                        Inserire di seguito il numero di protocollo della DSU
                                        (Dichiarazione Sostitutiva Unica) presentata a INPS per
                                        l’attestazione ISEE dello studente beneficiario o del nucleo
                                        famigliare a cui appartiene (dove trovare il{" "}
                                        <a
                                            href={protocolloDsu}
                                            className="rtds-action-link
                rtds-action-link--has-icon"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            numero di protocollo DSU?
                                            <svg
                                                className="rtds-icon rtds-fill-current rtds-h-6 rtds-w-6"
                                                aria-hidden="true"
                                                focusable="false"
                                                role="img"
                                            >
                                                <use
                                                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--arrow-small-right`}
                                                />
                                            </svg>
                                        </a>
                                        ).
                                    </p>
                                    <div className="rtds-field-row">
                                        <div className="rtds-input-field rtds-gap-1 ">
                                            <label className="rtds-input-field__label" htmlFor="dsu">
                                                Numero di protocollo della DSU&nbsp;
                                                <abbr
                                                    className="rtds-font-bold rtds-no-underline"
                                                    title="obbligatorio"
                                                >
                                                    *
                                                </abbr>
                                            </label>
                                            <div
                                                className={`rtds-input rtds-background-04 rtds-rounded-lg ${showError && errorDsu ? "has-error" : ""
                                                    }`}
                                            >
                                                <span
                                                    className="rtds-px-3 rtds-content-center rtds-content-03 rtds-whitespace-nowrap"
                                                    style={{ height: "var(--spacing-11)" }}
                                                >
                                                    {inpsIseeCurrentYear}
                                                </span>
                                                <IMaskInput
                                                    mask="00000000A-00"
                                                    value={dsu}
                                                    onAccept={handleDsuChange}
                                                    definitions={{
                                                        A: /[A-Za-z]/,
                                                    }}
                                                    overwrite
                                                    id="dsu"
                                                    className="rtds-text-sm rtds-input-placeholder rtds-pr-12"
                                                    inputRef={dsuInputRef}
                                                />

                                                <svg
                                                    className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-4 rtds-content-placeholder rtds-content-error"
                                                    aria-hidden="true"
                                                    focusable="false"
                                                    role="img"
                                                    hidden={!showError || !errorDsu}
                                                >
                                                    <use
                                                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-circle`}
                                                    />
                                                </svg>
                                            </div>
                                            <span
                                                hidden={!showError || !errorDsu}
                                                className="rtds-input-field__error"
                                            >
                                                DSU non valido
                                            </span>
                                        </div>
                                    </div>

                                </div>

                                <div id="div_container_iban" hidden={!richiesta?.hasErroreIbanBase}>

                                    <div className=" rtds-my-12 ">





                                        <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

                                        <h2 className="rtds-text-xl rtds-font-bold">Dati di pagamento</h2>
                                        <p>
                                            Indicare il codice IBAN del conto su cui si desidera ricevere il
                                            contributo.{" "}
                                        </p>

                                        <AlertMessage
                                            iconName="mini--information-circle"
                                            title="Attenzione!"
                                            message="L’IBAN deve essere intestato, o cointestato, al soggetto richiedente che sta presentando la domanda di accesso alla misura Libri Gratis."
                                        />

                                        <div className={`rtds-field-row relative`} >
                                            <InputIban
                                                label={"IBAN"}
                                                id={"iban"}
                                                classInput={
                                                    "rtds-text-sm rtds-input-placeholder rtds-uppercase"
                                                }
                                                type={"text"}
                                                onChange={validazioneIBANItaliano}
                                                value={richiestaDatiPagamento.iban || ""}
                                                required
                                                maxLength={27}
                                                minLength={27}
                                                classDiv={`${!showError || !errorIban ? "" : "has-error"
                                                    }`}
                                                errorIban={showError && errorIban}
                                                errorMessage={"Iban non valido"}
                                            />
                                            <Input
                                                label={"Nome banca"}
                                                id={"denominazione"}
                                                inputErrors={inputErrors}
                                                classInput={"rtds-text-sm rtds-input-placeholder"}
                                                type={"text"}
                                                onChange={(event) =>
                                                    onChangeValue(event, "value", "denominazioneBanca")
                                                }
                                                value={richiestaDatiPagamento.denominazioneBanca || ""}
                                                required
                                                maxLength={255}
                                            />
                                        </div>

                                        <span hidden={!showError || !errorIban} className="rtds-input-field__error">Iban non valido</span>


                                    </div>

                                </div>

                                <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

                                <div className="rtds-mb-6">
                                    <fieldset className="rtds-input-field rtds-gap-2">
                                        <legend className="rtds-input-field__label">
                                            {"Dichiaro: "}
                                        </legend>

                                        <Checkbox
                                            classDiv={"rtds-input-checkbox rtds-input--lg"}
                                            id={"informativa1"}
                                            classLabel={"rtds-mr-8"}
                                            label={
                                                "di essere consapevole che, nel caso di ottenimento del contributo, possono essere eseguiti controlli, anche da parte della Guardia di Finanza, in applicazione dell'art.  4, commi  2  e  8,  del  D.Lgs.  n.109  del  31 marzo  1998,  in materia di controllo della veridicità delle informazioni fornite; "
                                            }
                                            inputErrors={inputErrors}
                                            onChange={onChangeValueCheckBox}
                                            checked={
                                                informativa1 ||
                                                false
                                            }
                                            required={true}
                                            disabled={
                                                !richiesta?.canBeUpdated
                                            }
                                        />

                                        <Checkbox
                                            classDiv={"rtds-input-checkbox rtds-input--lg"}
                                            classLabel={"rtds-mr-8"}
                                            id={"informativa2"}
                                            label={
                                                "di essere consapevole delle sanzioni penali nel caso di dichiarazioni non veritiere, di formazione o uso di atti falsi, richiamate dall'art. 76 del D.P.R. 28.12.2000, n. 445;"
                                            }
                                            inputErrors={inputErrors}
                                            onChange={onChangeValueCheckBox}
                                            checked={
                                                informativa2 ||
                                                false
                                            }
                                            required={true}
                                            disabled={
                                                !richiesta?.canBeUpdated
                                            }
                                        />
                                        <Checkbox
                                            classDiv={"rtds-input-checkbox rtds-input--lg"}
                                            classLabel={"rtds-mr-8"}
                                            id={"informativa3"}
                                            label={
                                                "di avere diritto al contributo in quanto esistono le condizioni di spettanza alla data di presentazione della domanda, impegnandosi a comunicare le eventuali successive variazioni secondo la procedura esposta nell'Avviso Libri Gratis, di cui si invita a prendere attenta e completa visione."
                                            }
                                            inputErrors={inputErrors}
                                            onChange={onChangeValueCheckBox}
                                            checked={
                                                informativa3 ||
                                                false
                                            }
                                            required={true}
                                            disabled={
                                                !richiesta?.canBeUpdated
                                            }
                                        />
                                    </fieldset>
                                    { }
                                </div>

                                <div
                                    className="rtds-mb-6"
                                >
                                    <AlertMessage
                                        title="Attenzione!"
                                        message="Verificare tutti i dati inseriti prima di rettificare la domanda."
                                        classDiv={""}
                                        classArticle={""}
                                        iconName={"mini--information-circle"}
                                    />
                                </div>

                                <div
                                    className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center"

                                >
                                    <div className="rtds-form-actions">
                                        <div
                                            className="rtds-inline-flex rtds-gap-1"
                                            role="group"
                                            aria-label="Ruolo"
                                        >
                                            <button
                                                type="button"
                                                className="rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button"
                                                disabled={inSave}
                                                aria-busy={inSave}

                                                onClick={presentaDomanda}
                                            >
                                                {"Rettifica domanda"}

                                                {inSave ? (
                                                    <>
                                                        <svg
                                                            className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            role="img"
                                                        >
                                                            <use
                                                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                                                            />
                                                        </svg>
                                                        <span className="rtds-sr-only">Caricamento...</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <svg
                                                            className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            role="img"
                                                        >
                                                            <use
                                                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                                                            />
                                                        </svg>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={isModalOpen}
                    title={title}
                    content={content}
                    onAction={handleModalAction}
                    actionLabel={actionLabel}
                    closeLabel="Annulla"
                    hideCloseButton={hideCloseButton}
                    icona={icon}
                    iconaClass={iconaClass}
                    iconaColorClass={iconaColorClass}
                    onClose={() => setModalOpen(false)}

                //disabledConfirmBtn={inSave}
                //disableCloseBtn={inSave}
                />
            </div>

        </>
    );
};

export default RettificaRipresentazione;
